import TextField from "../../../components/fields/textField/TextField.vue";
import PeriodoField from "../../../components/fields/periodoField/PeriodoField.vue";
import SelectField from "../../../components/fields/selectField/SelectField.vue";
import {
  FeriasVantagemService
} from "../../../services/FeriasVantagemService";

import { tipoPerfil } from "../../../constants";


export default {
  name: "FeriasVantagem",

  components: {
    TextField,
    PeriodoField,
    SelectField
  },

  data: () => ({
    headers: [{
        text: "Militar",
        value: "nome",
        sortable: false
      },
      {
        text: "Dias para Vantagem",
        value: "dias",
        sortable: false
      },
      {
        text: "Exercício",
        value: "exercicio",
        sortable: false
      },
      {
        text: "Fez juz ao Abono?",
        value: "status_abono",
        sortable: false
      }
    ],
    items: [],
    selected: [],

    exerciciosOptions: [],

    loading: {
      field: false,
      btn: false
    }
  }),

  beforeMount() {
    this.listarFeriasVantagem();
  },

 

  methods: {

    async listarFeriasVantagem() {
      const response = await FeriasVantagemService.listarFeriasVantagem();
      this.items = response
    },

    prepareForm() {
      const formData = new FormData();
      this.selected.forEach( (el, index) => {
        formData.append(`vantagem[${index}][id]`, el.id)
        formData.append(`vantagem[${index}][premio]`, el.premio)
        formData.append(`vantagem[${index}][dias]`, el.dias)
        formData.append(`vantagem[${index}][exercicio]`, el.exercicio)


      });
      this.sendForm(formData);
    },

    verificarAprovar(){
      return this.$store.state.user.Perfis.indexOf(tipoPerfil['GERENCIA']) != -1 || this.$store.state.user.Perfis.indexOf(tipoPerfil['COMANDANTE']) != -1 || this.$store.state.user.Perfis.indexOf(tipoPerfil['UNIDADE_APOIADORA']) != -1;
    },

    async sendForm(formData) {
      this.loading.btn = true;
      const response = await FeriasVantagemService.aprovarFeriasVantagem(formData);
      this.loading.btn = false;
      if (response) {
        this.selected = []
        this.close();
      }
      this.loading.btn = false;
    },
    close() {
      this.$emit("on-close");
      this.listarFeriasVantagem();
    },
  }

};